import React, { useState, useContext, createContext, useEffect } from "react";
import { SessionType } from "../../types/sessionType";
import { Socket } from "socket.io-client";
import { LS_SESSION_KEY } from "constants/constants";

type SessionContextType = {
    session: SessionType | null;
    setSession: React.Dispatch<React.SetStateAction<SessionType | null>>;
    socket: Socket | null;
    setSocket: React.Dispatch<React.SetStateAction<Socket | null>>;
    isSessionActive: boolean;
    setSessionIsActive: React.Dispatch<React.SetStateAction<boolean>>;
    showRequestFloorButton: boolean;
    setShowRequestFloorButton: React.Dispatch<React.SetStateAction<boolean>>;
    isRequestingFloor: boolean;
    setIsRequestingFloor: React.Dispatch<React.SetStateAction<boolean>>;
};

type SessionContextProviderProps = {
    children: React.ReactNode;
};

const SessionContext = createContext<SessionContextType>({
    session: null,
    setSession: () => {},
    socket: null,
    setSocket: () => {},
    isSessionActive: false,
    setSessionIsActive: () => {},
    showRequestFloorButton: false,
    setShowRequestFloorButton: () => {},

    isRequestingFloor: false,
    setIsRequestingFloor: () => {},
});

export const useSession = () => useContext(SessionContext);

export const SessionContextProvider = ({
    children,
}: SessionContextProviderProps) => {
    const [session, setSession] = useState<SessionType | null>(() => {
        const localSession = localStorage.getItem(LS_SESSION_KEY);
        return localSession ? JSON.parse(localSession) : null;
    });

    const [socket, setSocket] = useState<Socket | null>(null);

    const [isSessionActive, setSessionIsActive] = useState<boolean>(false);
    const [showRequestFloorButton, setShowRequestFloorButton] = useState(false);
    const [isRequestingFloor, setIsRequestingFloor] = useState(false);

    useEffect(() => {
        localStorage.setItem(LS_SESSION_KEY, JSON.stringify(session));
    }, [session]);

    return (
        <SessionContext.Provider
            value={{
                session,
                setSession,
                socket,
                setSocket,
                isSessionActive,
                setSessionIsActive,
                showRequestFloorButton,
                setShowRequestFloorButton,
                isRequestingFloor,
                setIsRequestingFloor,
            }}
        >
            {children}
        </SessionContext.Provider>
    );
};
